import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import AzureSubscriptionPicker, {
  AzureSubscriptionPickerFieldSchema,
} from './AzureSubscriptionPickerExtension';
import { validateAzureSubscription } from './validator';

export const azureSubscriptionPickerField = {
  name: 'AzureSubscriptionPicker',
  component: AzureSubscriptionPicker,
  schema: AzureSubscriptionPickerFieldSchema,
  validation: validateAzureSubscription,
};

export const AzureSubscriptionPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...azureSubscriptionPickerField,
    schema: AzureSubscriptionPickerFieldSchema.schema,
  }),
);
